export default {
  currencySetting(state) {
    return state.currencySetting;
  },
  hasCurrencySetting(state) { 
    return state.currencySetting && typeof state.currencySetting === 'object' && Object.keys(state.currencySetting).length > 0;
  }
};
